<div class="xi-modal__container session-expiration-warning__container">
  <h2>Your session is about to expire!</h2>
  <p>You will be logged out {{ minutesRemaining }}</p>
  <p>Do you want to stay signed in?</p>
  <div class="session-expiration-warning__action">
    <xi-default-button text="Stay logged in" (onClick)="confirm()"></xi-default-button>
  </div>
</div>
